import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function Gallery({ items }) {
    const showItems = items;
    return (
        <section id="gallery" data-testid="gallery-section" className="relative bg-[color:var(--bg-primary)] py-24 md:py-40">
            <div className="mx-auto max-w-[1440px] px-6 md:px-10">
                <div className="mb-16 md:mb-20 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
                    <div>
                        <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-neutral-500">[ Selected Work — 03 ]</div>
                        <h2 className="mt-4 font-display text-5xl md:text-7xl font-black tracking-tighter leading-[0.88] text-neutral-900">
                            Recent projects<br />in Baton Rouge.
                        </h2>
                    </div>
                    <a href="#contact" className="hidden md:inline-flex items-center gap-2 text-sm font-semibold text-neutral-900 hover:text-[color:var(--brand-blue)] transition-colors">
                        Request a similar project <ArrowUpRight className="h-4 w-4" />
                    </a>
                </div>

                {showItems.length === 0 ? (
                    <div className="border border-dashed border-neutral-300 py-24 text-center text-neutral-500">
                        Gallery is being updated.
                    </div>
                ) : (
                    <div className="grid grid-cols-12 gap-4 md:gap-6" data-testid="gallery-grid">
                        {showItems.map((item, i) => {
                            // Vary layout: 0,3 span 7; 1,4 span 5; 2,5 span 6/6
                            const spans = [
                                "col-span-12 md:col-span-7",
                                "col-span-12 md:col-span-5",
                                "col-span-12 md:col-span-6",
                                "col-span-12 md:col-span-6",
                                "col-span-12 md:col-span-5",
                                "col-span-12 md:col-span-7",
                            ];
                            const aspects = [
                                "aspect-[4/3]",
                                "aspect-[4/3]",
                                "aspect-[5/4]",
                                "aspect-[5/4]",
                                "aspect-[4/3]",
                                "aspect-[4/3]",
                            ];
                            return (
                                <motion.figure
                                    key={item.id}
                                    initial={{ opacity: 0, y: 40 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, margin: "-80px" }}
                                    transition={{ delay: (i % 3) * 0.08, duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                                    className={`group relative ${spans[i % 6]}`}
                                    data-testid={`gallery-item-${i}`}
                                >
                                    <div className={`relative overflow-hidden ${aspects[i % 6]} ${i % 2 === 0 ? "clip-frame" : "clip-frame-alt"} bg-neutral-100`}>
                                        <img
                                            src={item.image_url}
                                            alt={item.title}
                                            loading="lazy"
                                            className="w-full h-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.05]"
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-neutral-900/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                                        <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-500">
                                            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/70">{item.category}</div>
                                            <div className="mt-2 font-display text-xl md:text-2xl font-bold text-white tracking-tight">{item.title}</div>
                                            {item.caption && <div className="mt-1 text-xs text-white/80">{item.caption}</div>}
                                        </div>
                                    </div>
                                </motion.figure>
                            );
                        })}
                    </div>
                )}
            </div>
        </section>
    );
}
